<template>
    <div class="bg-primary-lighter py-4 px-8 rounded md:flex md:items-center md:justify-between">
        <div class="py-2 px-4 rounded-md text-primary">
            <strong>{{ message }}</strong>
        </div>
        <button class="min-w-max py-2 px-4 rounded-md bg-primary text-white font-bold" @click="upgrade">
            Upgrade plan
        </button>
    </div>
</template>

<script>
export default {
    props: {
        message : {
          type: String,
          default: 'Upgrade to premium and unlock all these features.'
      }
    },
    methods: {
        upgrade() {
            window.location.href = '/billing';
        }
    }
}
</script>
